import { group } from "console";
import acompanamiento from "../dashboard/profuturo/staticDashboards/acompanamiento";
import ventaPrestamosSOFOM from "../dashboard/profuturo/staticDashboards/ventaPrestamosSOFOM";
import { OmoikaneConfig, OmoikaneTab } from "./omoikaneCommons";

// TODO: mover estos metodos a commons cuando este probado se podria unificar con getCJIndicators de commonwiegets
const getIndicator = (config: { [key: string]: any } = {}) => {
    return {
        id: config.id ?? undefined,
        indicator: config.name,
        keyExtract: [],
        key: config.key ?? config.name,
        grouped: config.grouped ?? "question",
        extras: {
            omoikane: config?.omoikane ?? true,
            groupNameFormat: config?.groupNameFormat ?? "description",
            criticalMomentInclude: config.criticalMomentInclude ?? [],
            resultType: config.resultType ?? undefined,
            formula: config.formula ?? undefined,
        }
    };
};

const getCommentIndicator = (config: { [key: string]: any } = {}) => {
    const indicatorConfigs = getIndicator(config)
    return {
        ...indicatorConfigs,
        grouped: undefined,
    }
};

const getSentimentIndicator = (key: string, criticalMomentInclude: number[]) => {
    const config = {
        name: 'SENTIMENT',
        key: key,
        grouped: 'tag',
        criticalMomentInclude: criticalMomentInclude

    }
    return getIndicator(config);
}

const getCountIndicator = (key: string, criticalMomentInclude: number[]) => {
    const config = {
        name: 'SURVEY_COUNT',
        key: key,
        grouped: 'mlCluster',
        criticalMomentInclude: criticalMomentInclude
    }
    return getIndicator(config);
}

const getClusterIndicators = (csatIndicator: string, npsIndicator: string, criticalMomentInclude: number[]) => {
    return [
        getIndicator({ name: csatIndicator, id: 'csat', grouped: 'mlCluster', criticalMomentInclude: criticalMomentInclude }),
        getIndicator({ name: npsIndicator, id: 'nps', grouped: 'mlCluster', criticalMomentInclude: criticalMomentInclude }),
        getIndicator({ name: 'SENTIMENT', id: 'best-tags', grouped: 'mlCluster,tag', criticalMomentInclude: criticalMomentInclude, resultType: 'top' }),
        getIndicator({ name: 'SENTIMENT', id: 'worst-tags', grouped: 'mlCluster,tag', criticalMomentInclude: criticalMomentInclude, resultType: 'bottom' }),
        getCommentIndicator({ name: 'COMMENTS', id: 'last-comments', criticalMomentInclude: criticalMomentInclude }),
        getIndicator({ name: 'SURVEY_COUNT', id: 'alerts', grouped: 'mlCluster', criticalMomentInclude: criticalMomentInclude }),
        getIndicator({ name: 'ALERT_COUNTERS', id: 'alerts-counters', grouped: 'mlCluster,alertType', criticalMomentInclude: criticalMomentInclude })

    ]

}

const getCJIndicatorItems = (data: any, indicatorNames: string[]) => {
    const items: any[] = [];
    let pos = 1;

    indicatorNames.forEach((indicatorName) => {
        if (data && data[indicatorName]?.data) {

            const sortedValues = data[indicatorName]?.data
                .asMutable()
                .sort((c1: any, c2: any) => c1.groupId - c2.groupId)
                .map((item: any) => ({ value: item.value, name: indicatorName, group: item.group }));

            const item = sortedValues?.[0];
            //const item2 = sortedValues?.[1];  

            items.push({
                key: pos,
                number: (pos).toString(),
                title: item.group,
                items: [
                    { order: 1, name: '', value: item.value }
                ]
            });
            pos++;

        }
    });

    return items;
};

export const omoikaneHonda: OmoikaneConfig = {

    decimals: 2,
    enabledTabs: [
        OmoikaneTab.CUSTOMER_JORUNEY,
        OmoikaneTab.CX_RAY,
        OmoikaneTab.CX_ROAD_MAP,
        //OmoikaneTab.CLUSTERS
    ],
    monthdsCoverage: 2,
    indicators: [

        //Ventas
        getIndicator({ name: 'hon_vta_atencion_rapida', formula: 'nps-5' }), // atencion
        getIndicator({ name: 'hon_vta_ejecutivo_vta_interesado', formula: 'nps-5' }), // facilidad
        getIndicator({ name: 'hon_vta_instal_agradables', formula: 'nps-5' }), // csat
        getIndicator({ name: 'hon_vta_prueba_agradable', formula: 'nps-5' }), // nps
        getIndicator({ name: 'hon_vta_finance_proceso_financiamiento', formula: 'nps-5' }), // nps
        getIndicator({ name: 'hon_vta_entrega_agil', formula: 'nps-5' }), // csat
        getIndicator({ name: 'hon_vta_recibio_seguimiento', formula: 'nps-5' }), // csat

        getIndicator({ name: 'hon_vta_npm_recom_prueba', formula: 'nps-10' }), // nps
        getIndicator({ name: 'hon_vta_npm_satisf_gral', formula: 'nps-10' }), // nps
        
        //Post Ventas
        getIndicator({ name: 'hon_postvta_npm_prontitud_ingreso', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_conocimientos_asesor', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_tiempo_servicio', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_minuciosidad_trabajo', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_tiempo_administrativo', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_condicion_vehiculo_devuelto', formula: 'nps-5' }),
        getIndicator({ name: 'hon_postvta_npm_regresaria', formula: 'nps-10' }), // nps

        //Post Ventas Motos

        getIndicator({ name: 'hon_moto_pv_npm_agendo_cita', formula: 'nps-5' }),
        getIndicator({ name: 'hon_moto_pv_npm_eficiencia_recepcion', formula: 'nps-5' }),
        getIndicator({ name: 'hon_moto_pv_npm_limpieza_unidad', formula: 'nps-5' }),
        getIndicator({ name: 'hon_moto_pv_npm_servicio_valor', formula: 'nps-5' }),
        getIndicator({ name: 'hon_moto_pv_nps', formula: 'nps-10' }), // nps
        

        getSentimentIndicator('sentiment-ventas', [13101]),
        getSentimentIndicator('sentiment-post-ventas', [13551]),
        getSentimentIndicator('sentiment-post-ventas-motos', [13554]),

    ],
    sentiment: {
        indicators: {
            Ventas: 'sentiment-ventas',
            PostVentas: 'sentiment-post-ventas',
            MotosPostVentas: 'sentiment-post-ventas-motos',
            

        },
        properties: { ///revisar!
            sentiment: 'sentimentGlobal',
            percentage: 'percentageGlobal',
            sentimentLocal: 'sentimentLocal',
            percentageLocal: 'percentageLocal'
        }
    },
    cxRay: {
        indicators: {
            Ventas: [
                { order: 1, name: 'NPS', key: 'hon_vta_npm_recom_prueba', widgetType: 'pie' },
                { order: 2, name: 'CSAT', key: 'hon_vta_npm_satisf_gral', widgetType: 'gauge' },
            ],
            PostVentas: [
                { order: 1, name: 'NPS', key: 'hon_postvta_npm_regresaria', widgetType: 'pie' },
                //{ order: 2, name: 'CSAT', key: 'hon_postvta_npm_regresaria', widgetType: 'gauge' },
            ],
            MotosPostVentas: [
                { order: 1, name: 'NPS', key: 'hon_moto_pv_nps', widgetType: 'pie' },
                //{ order: 2, name: 'CSAT', key: 'hon_moto_pv_npm_servicio_valor', widgetType: 'gauge' },
            ],
        }
    },
    clusters: {
        Ventas: {
            counters: { indicator: 'survey-count-ventas' },
            detail: { indicators: getClusterIndicators('hon_vta_npm_recom_prueba', 'hon_vta_npm_satisf_gral', [13101]) },
        },
        PostVentas: {
            counters: { indicator: 'survey-count-postventas' },
            detail: { indicators: getClusterIndicators('hon_postvta_npm_regresaria', 'hon_postvta_npm_regresaria', [13551]) },
        },
        MotosPostVentas: {
            counters: { indicator: 'survey-count-motospostventas' },
            detail: { indicators: getClusterIndicators('hon_moto_pv_npm_servicio_valor', 'hon_moto_pv_npm_servicio_valor', [13554]) },
        },                     

    },
    customerJourney: {

        Ventas: (data: any) => {
            return getCJIndicatorItems(data, [
                'hon_vta_atencion_rapida',
                'hon_vta_ejecutivo_vta_interesado',
                'hon_vta_instal_agradables',
                'hon_vta_prueba_agradable',
                'hon_vta_finance_proceso_financiamiento',
                'hon_vta_entrega_agil',
                'hon_vta_recibio_seguimiento',
            ])
        },
        PostVentas: (data: any) => {
            return getCJIndicatorItems(data, [
                'hon_postvta_npm_prontitud_ingreso',
                'hon_postvta_npm_conocimientos_asesor',
                'hon_postvta_npm_tiempo_servicio',
                'hon_postvta_npm_minuciosidad_trabajo',
                'hon_postvta_npm_tiempo_administrativo',
                'hon_postvta_npm_condicion_vehiculo_devuelto',
            ])
        },
        MotosPostVentas: (data: any) => {
            return getCJIndicatorItems(data, [
                'hon_moto_pv_npm_agendo_cita',
                'hon_moto_pv_npm_eficiencia_recepcion',
                'hon_moto_pv_npm_limpieza_unidad',
                'hon_moto_pv_npm_servicio_valor',
            ])
        },                    

    }
}
